// Helper para mostrar el modal de reseña con alertas inteligentes de historial
import { registrarSolicitudReview } from '../api/backend_v2';
import { construirUrlWhatsApp } from './whatsappHelper';

export function calcularTiempoTranscurrido(fechaIsoStr) {
  if (!fechaIsoStr) return '';
  const fecha = new Date(fechaIsoStr);
  if (isNaN(fecha.getTime())) return '';

  const ahora = new Date();
  const diffMs = ahora - fecha;
  if (diffMs < 0) return 'hace un momento';

  const diffSegundos = Math.floor(diffMs / 1000);
  const diffMinutos = Math.floor(diffSegundos / 60);
  const diffHoras = Math.floor(diffMinutos / 60);
  const diffDias = Math.floor(diffHoras / 24);

  if (diffDias === 0) {
    if (diffHoras === 0) {
      if (diffMinutos <= 5) return 'hace unos minutos';
      return `hace ${diffMinutos} minutos`;
    }
    return `hace ${diffHoras} hs`;
  }
  if (diffDias === 1) return 'ayer';
  if (diffDias < 7) return `hace ${diffDias} días`;

  const diffSemanas = Math.floor(diffDias / 7);
  if (diffDias < 30) {
    return diffSemanas === 1 ? 'hace 1 semana' : `hace ${diffSemanas} semanas`;
  }

  const diffMeses = Math.floor(diffDias / 30);
  if (diffMeses < 12) {
    return diffMeses === 1 ? 'hace 1 mes' : `hace ${diffMeses} meses`;
  }

  const diffAnios = Math.floor(diffDias / 365);
  return diffAnios === 1 ? 'hace 1 año' : `hace ${diffAnios} años`;
}

export function formatearFechaCorta(fechaIsoStr) {
  if (!fechaIsoStr) return '';
  try {
    const f = new Date(fechaIsoStr);
    if (isNaN(f.getTime())) return '';
    return f.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch (_e) {
    return '';
  }
}

export async function mostrarModalReview({
  preview,
  Swal,
  formatearTelefonoWALista,
  onReviewRegistrada,
}) {
  const urlWA = construirUrlWhatsApp(preview.telefono, preview.mensaje);

  let headerBannerHtml = '';
  if (preview.review_realizado) {
    headerBannerHtml = `
      <div class="mb-3 p-3 bg-amber-50 border border-amber-200 rounded-xl text-left text-xs text-amber-900 shadow-xs">
        <p class="font-bold flex items-center gap-1 text-amber-800">⭐ Reseña confirmada</p>
        <p class="mt-0.5">El cliente <strong>${preview.cliente_nombre || preview.destinatario_nombre}</strong> ya nos dejó su reseña anteriormente. ¿Querés enviarle la invitación de todas formas?</p>
      </div>`;
  } else if (preview.review_solicitado && preview.fecha_review_solicitado) {
    const fechaFmt = formatearFechaCorta(preview.fecha_review_solicitado);
    const tiempoTrans = calcularTiempoTranscurrido(preview.fecha_review_solicitado);
    headerBannerHtml = `
      <div class="mb-3 p-3 bg-blue-50 border border-blue-200 rounded-xl text-left text-xs text-blue-900 shadow-xs">
        <p class="font-bold flex items-center gap-1 text-blue-800">ℹ️ Solicitud previa registrada</p>
        <p class="mt-0.5">Al cliente <strong>${preview.cliente_nombre || preview.destinatario_nombre}</strong> ya se le solicitó una reseña el <strong>${fechaFmt}</strong> (${tiempoTrans}). ¿Querés solicitarle nuevamente?</p>
      </div>`;
  } else {
    headerBannerHtml = `
      <p class="text-sm text-gray-600 mb-3">¿Querés invitar a <strong>${preview.destinatario_nombre}</strong> a dejar un review?</p>`;
  }

  const result = await Swal.fire({
    title: '⭐ Invitar a dejar review',
    html: `
      ${headerBannerHtml}
      <div class="bg-gray-50 border border-gray-200 rounded-xl p-3 text-left text-xs whitespace-pre-wrap text-gray-800 mb-4 font-sans leading-relaxed" style="max-height:180px;overflow-y:auto">
        ${preview.mensaje}
      </div>
      <button id="btnCompartirWA" class="w-full inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl bg-green-500 hover:bg-green-600 text-white font-semibold text-sm shadow-md transition-colors">
        💬 Compartir por WhatsApp
      </button>`,
    showConfirmButton: false,
    showCloseButton: true,
    didOpen: () => {
      const btn = document.getElementById('btnCompartirWA');
      if (btn) {
        btn.addEventListener('click', async () => {
          try {
            if (preview.cliente_id) {
              await registrarSolicitudReview(preview.cliente_id);
              if (onReviewRegistrada) onReviewRegistrada();
            }
          } catch (err) {
            console.error('Error al registrar solicitud de review:', err);
          }
          window.open(urlWA, '_blank', 'noopener,noreferrer');
          Swal.close();
        });
      }
    },
  });

  return result;
}
